// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ReportUserForm-space1-by5eZ {
	margin-bottom: 6px !important;
}

.ReportUserForm-space2-dSoFB {
	margin-bottom: 12px !important;
}

.ReportUserForm-space3-sfhLJ {
	margin-bottom: 18px !important;
}

.ReportUserForm-space4-kjJ_F {
	margin-bottom: 24px !important;
}

.ReportUserForm-space5-sadDu {
	margin-bottom: 30px !important;
}

.ReportUserForm-space6-VaZTz {
	margin-bottom: 36px !important;
}

.ReportUserForm-space7-imOOi {
	margin-bottom: 42px !important;
}

.ReportUserForm-spaceTop8-SOh_z {
	margin-bottom: 48px !important;
}

.ReportUserForm-spaceTop1-rKeME {
	margin-top: 6px !important;
}

.ReportUserForm-spaceTop2-LC5SN {
	margin-top: 12px !important;
}

.ReportUserForm-spaceTop3-mfbye {
	margin-top: 18px !important;
}

.ReportUserForm-spaceTop4-qBhlZ {
	margin-top: 24px !important;
}

.ReportUserForm-spaceTop5-BS8fK {
	margin-top: 30px !important;
}

.ReportUserForm-spaceTop6-JpH6u {
	margin-top: 36px !important;
}

.ReportUserForm-spaceTop7-sktg7 {
	margin-top: 42px !important;
}

.ReportUserForm-spaceTop8-SOh_z {
	margin-top: 48px !important;
}

.ReportUserForm-noMargin-Fq0IH {
	margin: 0px !important;
}

.ReportUserForm-padding1-hqy6o {
	padding-bottom: 6px !important;
}

.ReportUserForm-padding2-eZrzx {
	padding-bottom: 12px !important;
}

.ReportUserForm-padding3-k44Rz {
	padding-bottom: 18px !important;
}

.ReportUserForm-padding4-MQjim {
	padding-bottom: 24px !important;
}

.ReportUserForm-padding5-B52kE {
	padding-bottom: 30px !important;
}

.ReportUserForm-padding6-ahAkU {
	padding-bottom: 36px !important;
}

.ReportUserForm-padding7-MoqXo {
	padding-bottom: 42px !important;
}

.ReportUserForm-paddingTop1-uRxKa {
	padding-top: 6px !important;
}

.ReportUserForm-paddingTop2-lveTY {
	padding-top: 12px !important;
}

.ReportUserForm-paddingTop3-Qo8Xv {
	padding-top: 18px !important;
}

.ReportUserForm-paddingTop4-tQrjb {
	padding-top: 24px !important;
}

.ReportUserForm-paddingTop5-FH9aF {
	padding-top: 30px !important;
}

.ReportUserForm-paddingTop6-cs5Nd {
	padding-top: 36px !important;
}

.ReportUserForm-paddingTop7-KJPfC {
	padding-top: 42px !important;
}

.ReportUserForm-noPadding-PzxgE {
	padding: 0px !important;
}

.ReportUserForm-textBold-L3KUp {
	font-weight: 500 !important;
}

.ReportUserForm-textBolder-zJTR9 {
	font-weight: 700 !important;
}

.ReportUserForm-textNormal-u0DM0 {
	font-weight: normal !important;
}

.ReportUserForm-spaceBottom20-ooPg8 {
	margin-bottom: 20px;
}

.ReportUserForm-spaceBottom10-piOWw {
	margin-bottom: 10px;
}

.ReportUserForm-marginNone-kKKv_ {
	margin: 0;
}

.ReportUserForm-spaceBottom15-bWO28 {
	margin-bottom: 15px;
}

.ReportUserForm-marginTopNone-osS8z {
	margin-top: 0;
}

.ReportUserForm-spaceTop11-LrLxB {
	margin-top: 11px;
}

.ReportUserForm-spaceTop21-joZK6 {
	margin-top: 21px;
}

.ReportUserForm-spaceTop20-wjyoA {
	margin-top: 20px;
}

.ReportUserForm-spaceTop10-hiYgU {
	margin-top: 10px;
}

/*New Design Text Colors */

.ReportUserForm-textDarkBlue-j432t {
	color: rgb(20, 39, 94) !important;
}

.ReportUserForm-textLightBlue-ojX5M {
	color: rgb(57, 87, 106) !important;
}

.ReportUserForm-textLightSandleGreen-YSEmA {
	color: rgb(76, 86, 41) !important;
}

.ReportUserForm-textLightBrown-a80_h {
	color: rgb(115, 79, 33) !important;
}

.ReportUserForm-textMediumMaroon-n83y2 {
	color: rgb(87, 37, 51) !important;
}

.ReportUserForm-textBrown-nzUO2 {
	color: rgb(160, 47, 24) !important;
}

.ReportUserForm-textMaroon-kp3_t {
	color: rgb(155, 49, 67) !important;
}

.ReportUserForm-textDarkBrown-I63Kp {
	color: rgb(83, 18, 16) !important;
}

.ReportUserForm-textMediumBrown-Fi1hH {
	color: rgb(142, 28, 10) !important;
}

.ReportUserForm-textSkyBlue-N7O3p {
	color: rgb(37, 117, 141) !important;
}

.ReportUserForm-textGray-QrAzI {
	color: rgb(77, 65, 51) !important;
}

/** Common Styles  start**/

.ReportUserForm-landingLabel-gtX74 {
	font-size: 16px;
	font-weight: normal;
	margin-bottom: 18px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: start;
	    -ms-flex-align: start;
	        align-items: flex-start;
}

.ReportUserForm-noMarginBottom-LhNiD {
	margin-bottom: 0;
}

.ReportUserForm-titleText-FJqRm {
	font-size: 18px;
	margin-bottom: 24px;
}

.ReportUserForm-blockRadioButton-uRw6x {
	margin-right: 12px !important;
}

.ReportUserForm-flexEnd-g6vPy {
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-pack: end;
	    -ms-flex-pack: end;
	        justify-content: flex-end;
}

/** Common Styles  start**/`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/ReportUserForm/ReportUserForm.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC1NA,0BAA0B;;AAC1B;CACC,eAAe;CACf,mBAAmB;CACnB,mBAAmB;CACnB,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,wBAAuB;KAAvB,qBAAuB;SAAvB,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,eAAe;CACf,mBAAmB;AACpB;;AAEA;CACC,6BAA6B;AAC9B;;AAEA;CACC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,qBAAyB;KAAzB,kBAAyB;SAAzB,yBAAyB;AAC1B;;AAEA,0BAA0B","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../components/helpers.css';\n\n/** Common Styles  start**/\n.landingLabel {\n\tfont-size: 16px;\n\tfont-weight: normal;\n\tmargin-bottom: 18px;\n\tdisplay: flex;\n\talign-items: flex-start;\n}\n\n.noMarginBottom {\n\tmargin-bottom: 0;\n}\n\n.titleText {\n\tfont-size: 18px;\n\tmargin-bottom: 24px;\n}\n\n.blockRadioButton {\n\tmargin-right: 12px !important;\n}\n\n.flexEnd {\n\tdisplay: flex;\n\tjustify-content: flex-end;\n}\n\n/** Common Styles  start**/"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `ReportUserForm-space1-by5eZ`,
	"space2": `ReportUserForm-space2-dSoFB`,
	"space3": `ReportUserForm-space3-sfhLJ`,
	"space4": `ReportUserForm-space4-kjJ_F`,
	"space5": `ReportUserForm-space5-sadDu`,
	"space6": `ReportUserForm-space6-VaZTz`,
	"space7": `ReportUserForm-space7-imOOi`,
	"spaceTop8": `ReportUserForm-spaceTop8-SOh_z`,
	"spaceTop1": `ReportUserForm-spaceTop1-rKeME`,
	"spaceTop2": `ReportUserForm-spaceTop2-LC5SN`,
	"spaceTop3": `ReportUserForm-spaceTop3-mfbye`,
	"spaceTop4": `ReportUserForm-spaceTop4-qBhlZ`,
	"spaceTop5": `ReportUserForm-spaceTop5-BS8fK`,
	"spaceTop6": `ReportUserForm-spaceTop6-JpH6u`,
	"spaceTop7": `ReportUserForm-spaceTop7-sktg7`,
	"noMargin": `ReportUserForm-noMargin-Fq0IH`,
	"padding1": `ReportUserForm-padding1-hqy6o`,
	"padding2": `ReportUserForm-padding2-eZrzx`,
	"padding3": `ReportUserForm-padding3-k44Rz`,
	"padding4": `ReportUserForm-padding4-MQjim`,
	"padding5": `ReportUserForm-padding5-B52kE`,
	"padding6": `ReportUserForm-padding6-ahAkU`,
	"padding7": `ReportUserForm-padding7-MoqXo`,
	"paddingTop1": `ReportUserForm-paddingTop1-uRxKa`,
	"paddingTop2": `ReportUserForm-paddingTop2-lveTY`,
	"paddingTop3": `ReportUserForm-paddingTop3-Qo8Xv`,
	"paddingTop4": `ReportUserForm-paddingTop4-tQrjb`,
	"paddingTop5": `ReportUserForm-paddingTop5-FH9aF`,
	"paddingTop6": `ReportUserForm-paddingTop6-cs5Nd`,
	"paddingTop7": `ReportUserForm-paddingTop7-KJPfC`,
	"noPadding": `ReportUserForm-noPadding-PzxgE`,
	"textBold": `ReportUserForm-textBold-L3KUp`,
	"textBolder": `ReportUserForm-textBolder-zJTR9`,
	"textNormal": `ReportUserForm-textNormal-u0DM0`,
	"spaceBottom20": `ReportUserForm-spaceBottom20-ooPg8`,
	"spaceBottom10": `ReportUserForm-spaceBottom10-piOWw`,
	"marginNone": `ReportUserForm-marginNone-kKKv_`,
	"spaceBottom15": `ReportUserForm-spaceBottom15-bWO28`,
	"marginTopNone": `ReportUserForm-marginTopNone-osS8z`,
	"spaceTop11": `ReportUserForm-spaceTop11-LrLxB`,
	"spaceTop21": `ReportUserForm-spaceTop21-joZK6`,
	"spaceTop20": `ReportUserForm-spaceTop20-wjyoA`,
	"spaceTop10": `ReportUserForm-spaceTop10-hiYgU`,
	"textDarkBlue": `ReportUserForm-textDarkBlue-j432t`,
	"textLightBlue": `ReportUserForm-textLightBlue-ojX5M`,
	"textLightSandleGreen": `ReportUserForm-textLightSandleGreen-YSEmA`,
	"textLightBrown": `ReportUserForm-textLightBrown-a80_h`,
	"textMediumMaroon": `ReportUserForm-textMediumMaroon-n83y2`,
	"textBrown": `ReportUserForm-textBrown-nzUO2`,
	"textMaroon": `ReportUserForm-textMaroon-kp3_t`,
	"textDarkBrown": `ReportUserForm-textDarkBrown-I63Kp`,
	"textMediumBrown": `ReportUserForm-textMediumBrown-Fi1hH`,
	"textSkyBlue": `ReportUserForm-textSkyBlue-N7O3p`,
	"textGray": `ReportUserForm-textGray-QrAzI`,
	"landingLabel": `ReportUserForm-landingLabel-gtX74`,
	"noMarginBottom": `ReportUserForm-noMarginBottom-LhNiD`,
	"titleText": `ReportUserForm-titleText-FJqRm`,
	"blockRadioButton": `ReportUserForm-blockRadioButton-uRw6x`,
	"flexEnd": `ReportUserForm-flexEnd-g6vPy`
};
module.exports = ___CSS_LOADER_EXPORT___;
